import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import Partnership from '../views/Partners.vue';
import Contact  from '../views/Contact.vue';
import Platform from '../views/Platforms.vue';
//import Platform from '../views/Platforms';
import LegalTerms from '../views/LegalTerms.vue';
import Faq from '../views/Faq.vue';
import LegalMoney from '../views/LegalMoney.vue';
import LegalDocuments from '../views/LegalDocuments.vue';
import LegalRisk from '../views/LegalRisk.vue';
import LegalPrivacy from '../views/LegalPrivacy.vue';
import About from '../views/About.vue';
import TradingPlatform from '../views/TradingPlatform.vue';
import TradingAcademyTechnicalAnalysis from '../views/TradingAcademyTechnicalAnalysis.vue';
import TradingAcademyIndicators from '../views/TradingAcademyIndicators.vue';
import TradingAcademyBasics from '../views/TradingAcademyBasics.vue';
import TradingAcademyStrategies from '../views/TradingAcademyStrategies.vue';
import AccountTypes from '../views/AccountTypes.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/legal/terms',
    name: 'LegalTerms',
    component: LegalTerms
  },
  {
    path: '/legal/money',
    name: 'LegalMoney',
    component: LegalMoney
  },
  {
    path: '/legal/documents',
    name: 'LegalDocuments',
    component: LegalDocuments
  },
  {
    path: '/legal/risk',
    name: 'LegalRisk',
    component: LegalRisk
  },
  {
    path: '/legal/privacy',
    name: 'LegalPrivacy',
    component: LegalPrivacy
  },
  {
    path: '/partnership',
    name: 'Partnership',
    component: Partnership
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/platforms',
    name: 'Platforms',
    component: Platform
  },
  {
    path: '/trading-academy/strategies',
    name: 'TradingAcademyStrategies',
    component: TradingAcademyStrategies
  },
  {
    path: '/trading-academy/basics',
    name: 'Faq',
    component: Faq
  },
  {
    path: '/trading-academy/indicators',
    name: 'TradingAcademyIndicators',
    component: TradingAcademyIndicators
  },
  {
    path: '/trading-academy/technical-analysis',
    name: 'TradingAcademyTechnicalAnalysis',
    component: TradingAcademyTechnicalAnalysis
  },
  {
    path: '/trading-platform',
    name: 'TradingPlatform',
    component: TradingPlatform
  },
  {
    path: '/account-types',
    name: 'AccountTypes',
    component: AccountTypes
  },
]

const router = new VueRouter({
    mode: 'history',
    routes, // short for `routes: routes`
    scrollBehavior (to, from, savedPosition) {
      // page scroll to top for all route navigations
      return { x: 0, y: 0 }
    }
  })
export default router